module.exports = __webpack_public_path__ + "images/questions/qa_check_important_6f95287c45f3a3ed2f95070f5c344d1d.png";